import { LegalPage } from "@/components/LegalPage";

// Legal text. Change the wording only with the owner's sign-off, and update
// the date when you do.
export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="How MineOptics collects, uses and protects your information."
      path="/privacy"
      updated="January 2024"
    >
      <section>
        <h2>1. Introduction</h2>
        <p>
          MineOptics ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we
          collect, use, disclose, and safeguard your information when you use our mining cost modeling platform.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <h3>2.1 Information You Provide</h3>
        <ul>
          <li>Account information (name, email address, company name)</li>
          <li>Project data and cost models you create</li>
          <li>Payment and billing information</li>
          <li>Communications with our support team</li>
        </ul>
        <h3>2.2 Automatically Collected Information</h3>
        <ul>
          <li>Usage data and analytics</li>
          <li>Device information and IP addresses</li>
          <li>Cookies and similar tracking technologies</li>
          <li>Log files and error reports</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Process transactions and send related information</li>
          <li>Send administrative information, updates, and security alerts</li>
          <li>Respond to comments, questions, and provide customer support</li>
          <li>Monitor and analyze usage patterns and trends</li>
          <li>Detect, prevent, and address technical issues and security threats</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Sharing and Disclosure</h2>
        <p>We do not sell your personal information. We may share your information in the following circumstances:</p>
        <ul>
          <li>
            <strong>Service Providers:</strong> With third-party vendors who perform services on our behalf
          </li>
          <li>
            <strong>Legal Requirements:</strong> When required by law or to protect our rights
          </li>
          <li>
            <strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets
          </li>
          <li>
            <strong>With Your Consent:</strong> When you have given explicit permission
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>We implement security measures to protect your information, including:</p>
        <ul>
          <li>Encryption of data in transit</li>
          <li>Access controls and authentication measures</li>
          <li>Role-based access within each organization</li>
        </ul>
        <p>
          No method of transmission or storage is completely secure. See the <a href="/security">Security</a> page for
          what is in place today.
        </p>
      </section>

      <section>
        <h2>6. Data Retention</h2>
        <p>
          We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy
          Policy, unless a longer retention period is required or permitted by law.
        </p>
      </section>

      <section>
        <h2>7. Your Rights</h2>
        <p>Depending on your location, you may have the following rights:</p>
        <ul>
          <li>Access, update, or delete your personal information</li>
          <li>Object to or restrict processing of your data</li>
          <li>Data portability</li>
          <li>Withdraw consent at any time</li>
          <li>Lodge a complaint with a supervisory authority</li>
        </ul>
      </section>

      <section>
        <h2>8. Cookies and Tracking</h2>
        <p>
          We use cookies and similar tracking technologies to track activity on our service and hold certain information.
          You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
        </p>
      </section>

      <section>
        <h2>9. International Data Transfers</h2>
        <p>
          Your information may be transferred to and maintained on servers located outside of your jurisdiction where
          data protection laws may differ. We take appropriate safeguards to ensure your data remains protected.
        </p>
      </section>

      <section>
        <h2>10. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new
          Privacy Policy on this page and updating the "Last updated" date.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>If you have questions about this Privacy Policy, please contact us at:</p>
        <p>
          Email: <a href="mailto:privacy@mineoptics.com">privacy@mineoptics.com</a>
        </p>
      </section>
    </LegalPage>
  );
}
